import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';
import { DivisionWiseCropDetailsReportObject } from '../ValidationSchema';
import { validateProperty, validate } from "../../../Common";
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { reduceRight } from 'lodash';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core';
import MessageModal from '../../../../UI/Modal/MessageModal';

const useStyles = makeStyles((theme) => ({
    stickyHeader: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    sticky: {
        position: 'sticky',
        left: 0,
        top: 0,
        background: 'white',
        zIndex: 1,
    },
}));

const screenCode = 'DIVISIONWISECROPDETAILSREPORT';

const getCurrentYearMonth = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear().toString();
    const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    return { currentYear, currentMonth };
};

export function DivisionWiseCropDetailsReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [errors, setErrors] = useState({});
    const [resultCol, setResultCol] = useState([]);
    const [resultColOne, setResultColOne] = useState([]);
    const [resultColTwo, setResultColTwo] = useState([]);
    const [resultColThree, setResultColThree] = useState([]);
    const [resultColFour, setResultColFour] = useState([]);
    const [resultColFive, setResultColFive] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [totalRow, setTotalRow] = useState([]);
    const [estTotal, setEstTotal] = useState(0);
    const [osTotal, setOsTotal] = useState(0);
    const [rainFallAmountTotal, setRainFallAmountTotal] = useState(0);
    const schema = Joi.object(DivisionWiseCropDetailsReportObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);
    const { currentYear, currentMonth } = getCurrentYearMonth();

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            year: currentYear,
            month: currentMonth
        }
    );

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        feild: "",
        session: "",
        date: ""
    })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        if (searchForm.groupID !== "0") {
            trackPromise(
                getEsatesForDropDown(),
            )
        }
    }, [searchForm.groupID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDIVISIONWISECROPDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        const { currentYear, currentMonth } = getCurrentYearMonth();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                year: currentYear,
                month: currentMonth
            });

        } else {
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                estateID: token.operationEntityID,
                year: currentYear,
                month: currentMonth
            });
        }

        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID,
            year: currentYear,
            month: currentMonth
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            year: currentYear,
            month: currentMonth
        });
        clearGridData();
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            year: currentYear,
            month: currentMonth
        });
        clearGridData();
    }

    function clearGridData() {
        setResultCol([]);
        setResultColOne([]);
        setResultColTwo([]);
        setResultColThree([]);
        setResultColFour([]);
        setResultColFive([]);
        setTableData([]);
        setTotalRow([]);
        setEstTotal(0);
        setOsTotal(0);
        setRainFallAmountTotal(0);
    }

    function handleDateChange(target) {

        const [year, month] = target.value.split('-');

        const yearVariable = year;
        const monthVariable = month;

        setSearchForm({
            ...searchForm,
            year: yearVariable.toString(),
            month: monthVariable.toString()
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DivisionWiseCropDetailsReportObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }
    async function handleSearch(e) {
        e.preventDefault();
        getSelectedDropdownValuesForReport(searchForm);
        clearGridData();
        var reportData = await services.GetDivisionWiseCropDetailsReport(searchForm);
        if (reportData.statusCode == 'Error') {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        estateCropFormatData(reportData.data)
    }

    function estateCropFormatData(reportData) {
        let result = [];
        let resultOne = [];
        let resultTwo = [];
        let resultThree = [];
        let resultFour = [];
        let resultFive = [];

        let resultCol = [];
        let resultColOne = [];
        let resultColTwo = [];
        let resultColThree = [];
        let resultColFour = [];
        let resultColFive = [];

        let newData = reportData.estateCrop;
        let newDataOne = reportData.cashKgs;
        let newDataTwo = reportData.noOfPluckers;
        let newDataThree = reportData.sundryLabour;
        let newDataFour = reportData.outSource;
        let newDataFive = reportData.overKgs;

        if (newData.length > 0) {
            newData.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var rainFallAmount = x.rainFallAmount;
                var duplicateDate = result.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['EC ' + divisionCode] = duplicateDate['EC ' + divisionCode] == undefined ? 0 + x.estquantity
                        : duplicateDate['EC ' + divisionCode] + x.estquantity;
                    duplicateDate.dateOne = dateOne;
                    duplicateDate.ecTotal = duplicateDate.ecTotal + x.estquantity;
                    duplicateDate.rainFallAmount = rainFallAmount
                }
                else {
                    result.push({
                        ['EC ' + divisionCode]: x.estquantity,
                        dateOne: dateOne,
                        ecTotal: x.estquantity,
                        rainFallAmount: rainFallAmount

                    });
                }

                var duplicateCol = resultCol.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultCol.push({
                        colName: divisionCode,
                        colData: 'EC ' + divisionCode,
                        rainFallAmount: rainFallAmount
                    });
                }
                else {
                    duplicateCol.rainFallAmount = rainFallAmount;
                }
            })
            setResultCol(resultCol)
        }
        if (newDataOne.length > 0) {
            newDataOne.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var duplicateDate = resultOne.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['CK ' + divisionCode] = duplicateDate['CK ' + divisionCode] == undefined ? 0 + x.estquantity
                        : duplicateDate['CK ' + divisionCode] + x.estquantity;
                    duplicateDate.dateOne = dateOne;
                    duplicateDate.ckTotal = duplicateDate.ckTotal + x.estquantity
                }
                else {
                    resultOne.push({
                        ['CK ' + divisionCode]: x.estquantity,
                        dateOne: dateOne,
                        ckTotal: x.estquantity
                    });
                }

                var duplicateCol = resultColOne.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultColOne.push({
                        colName: divisionCode,
                        colData: 'CK ' + divisionCode
                    });
                }
            })
            setResultColOne(resultColOne)
        }
        if (newDataTwo.length > 0) {
            newDataTwo.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var duplicateDate = resultTwo.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['NP ' + divisionCode] = duplicateDate['NP ' + divisionCode] == undefined ? 0 + x.pluckersMandayCount
                        : duplicateDate['NP ' + divisionCode] + x.pluckersMandayCount;
                    duplicateDate.dateOne = dateOne;
                }
                else {
                    resultTwo.push({
                        ['NP ' + divisionCode]: x.pluckersMandayCount,
                        dateOne: dateOne
                    });
                }

                var duplicateCol = resultColTwo.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultColTwo.push({
                        colName: divisionCode,
                        colData: 'NP ' + divisionCode
                    });
                }
            })
            setResultColTwo(resultColTwo)
        }
        if (newDataThree.length > 0) {
            newDataThree.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var duplicateDate = resultThree.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['SL ' + divisionCode] = duplicateDate['SL ' + divisionCode] == undefined ? 0 + x.laboursCount
                        : duplicateDate['SL ' + divisionCode] + x.laboursCount;
                    duplicateDate.dateOne = dateOne;
                }
                else {
                    resultThree.push({
                        ['SL ' + divisionCode]: x.laboursCount,
                        dateOne: dateOne
                    });
                }
                var duplicateCol = resultColThree.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultColThree.push({
                        colName: divisionCode,
                        colData: 'SL ' + divisionCode
                    });
                }
            })
            setResultColThree(resultColThree)
        }
        if (newDataFour.length > 0) {
            newDataFour.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var duplicateDate = resultFour.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['OS ' + divisionCode] = duplicateDate['OS ' + divisionCode] == undefined ? 0 + x.estquantity
                        : duplicateDate['OS ' + divisionCode] + x.estquantity;
                    duplicateDate.dateOne = dateOne;
                    duplicateDate.osTotal = duplicateDate.osTotal + x.estquantity
                }
                else {
                    resultFour.push({
                        ['OS ' + divisionCode]: x.estquantity,
                        dateOne: dateOne,
                        osTotal: x.estquantity
                    });
                }
                var duplicateCol = resultColFour.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultColFour.push({
                        colName: divisionCode,
                        colData: 'OS ' + divisionCode
                    });
                }
            })
            setResultColFour(resultColFour)
        }
        if (newDataFive.length > 0) {
            newDataFive.forEach(x => {
                var dateOne = x.date.split('T')[0];
                var divisionCode = x.divisionCode;
                var duplicateDate = result.find(y => y.dateOne === dateOne);

                if (duplicateDate) {
                    duplicateDate['OK ' + divisionCode] = duplicateDate['OK ' + divisionCode] == undefined ? 0 + x.noamValue
                        : duplicateDate['OK ' + divisionCode] + x.noamValue;
                    duplicateDate.dateOne = dateOne;
                    duplicateDate.ecTotal = duplicateDate.ecTotal
                }
                else {
                    result.push({
                        ['OK ' + divisionCode]: x.noamValue,
                        dateOne: dateOne,
                        ecTotal: x.noamValue
                    });
                }

                var duplicateCol = resultColFive.find(y => y.colName === divisionCode);
                if (!duplicateCol) {
                    resultColFive.push({
                        colName: divisionCode,
                        colData: 'OK ' + divisionCode
                    });
                }
            })
            setResultColFive(resultColFive)
        }
        var finalResult = [];
        var joinedArrays = _.merge(
            _.keyBy(result, "dateOne"),
            _.keyBy(resultOne, "dateOne"),
            _.keyBy(resultTwo, "dateOne"),
            _.keyBy(resultThree, "dateOne"),
            _.keyBy(resultFour, "dateOne"),
            _.keyBy(resultFive, "dateOne")
        );
        Object.keys(joinedArrays).forEach((x) => finalResult.push(joinedArrays[x]));

        finalResult.forEach(x => {
            const ecTotal = isNaN(x.ecTotal) || x.ecTotal === undefined ? 0 : x.ecTotal;
            const ckTotal = isNaN(x.ckTotal) || x.ckTotal === undefined ? 0 : x.ckTotal;
            const osTotal = isNaN(x.osTotal) || x.osTotal === undefined ? 0 : x.osTotal;
            x.estTotal = ecTotal + ckTotal + osTotal;
        });

        finalResult.sort((a, b) => new Date(a.dateOne) - new Date(b.dateOne));
        setTableData(finalResult);
        calTotalRow(finalResult)
    }

    function calTotalRow(result) {
        var total = [];
        result.forEach(x => {
            for (var property in x) {
                if (property !== "dateOne") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });
        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + (value)), new Map
        ), ([name, value]) => ({ name, value }));
        const estTotal = res.find(x => x.name == 'estTotal')
        const osTotal = res.find(x => x.name == 'osTotal')
        const rainFallAmountTotal = res.find(x => x.name == 'rainFallAmount')
        setEstTotal(estTotal == undefined ? 0 : estTotal.value)
        setOsTotal(osTotal == undefined ? 0 : osTotal.value)
        setRainFallAmountTotal(rainFallAmountTotal == undefined ? 0 : rainFallAmountTotal.value)
        setTotalRow(res)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            year: searchForm.year,
            month: searchForm.month
        })
    }

    const sortByColName = (array) => {
        return array.sort((a, b) => a.colName.localeCompare(b.colName));
    };

    const sortedResultCol = sortByColName(resultCol);
    const sortedResultColFive = sortByColName(resultColFive);
    const sortedResultColOne = sortByColName(resultColOne);
    const sortedResultColTwo = sortByColName(resultColTwo);
    const sortedResultColThree = sortByColName(resultColThree);
    const sortedResultColFour = sortByColName(resultColFour);
    const monthValue = `${searchForm.year || currentYear}-${(searchForm.month || currentMonth).toString().padStart(2, '0')}`;

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <PageHeader
                            title="Division Wise Crop Details - TEA"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth

                                            id="estateID"
                                            name="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.estateID}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {estates && generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(estates).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="month"
                                            name="month"
                                            type="month"
                                            value={monthValue}
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        fullWidth
                                        type="submit"
                                        disabled={validate(schema, searchForm)}
                                        className="btn btn-primary"
                                        value="Generate"
                                    />
                                </div>
                            </form>
                            {tableData.length != 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Box display="flex" justifyContent="flex-end" >
                                                <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                    <Table className={classes.table} able size="small" aria-label="sticky table" Table stickyHeader>
                                                        <TableHead style={{ textAlign: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1000 }}>
                                                            <TableRow style={{ border: '2px solid black' }}>
                                                                <TableCell className={classes.sticky} rowSpan={3} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center', zIndex: 2000 }}>Date</TableCell>
                                                                <TableCell className={classes.sticky} rowSpan={3} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Rain Fall</TableCell>
                                                                <TableCell colSpan={2 + (sortedResultCol.length > 0 ? sortedResultCol.length : 1) + sortedResultColOne.length + sortedResultColTwo.length + sortedResultColThree.length + (sortedResultColFour.length > 0 ? sortedResultColFour.length : 1)}
                                                                    style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Estate Crop Details</TableCell>
                                                                <TableCell colSpan={2 + sortedResultColFive.length} style={{ border: '2px solid black', borderLeft: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Out Source Details</TableCell>
                                                            </TableRow>
                                                            <TableRow style={{ border: '2px solid black' }}>
                                                                <TableCell colSpan={sortedResultCol.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Estate Crop</TableCell>
                                                                <TableCell colSpan={sortedResultColFive.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Over Kgs</TableCell>
                                                                <TableCell colSpan={sortedResultColOne.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Cash Kgs</TableCell>
                                                                <TableCell colSpan={sortedResultColTwo.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Man days Of Pluckers</TableCell>
                                                                <TableCell colSpan={sortedResultColThree.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Sundry Labour</TableCell>
                                                                <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Total EST Crop</TableCell>
                                                                <TableCell colSpan={sortedResultColFour.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Green Leaf</TableCell>
                                                                <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Total OS Crop</TableCell>
                                                            </TableRow>
                                                            <TableRow style={{ border: '2px solid black' }}>
                                                                {sortedResultCol.length > 0 ? sortedResultCol.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                )) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                {sortedResultColFive.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                ))}
                                                                {sortedResultColOne.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                ))}
                                                                {sortedResultColTwo.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                ))}
                                                                {sortedResultColThree.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                ))}
                                                                {sortedResultColFour.length > 0 ? sortedResultColFour.map((data, index) => (
                                                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.colName}
                                                                    </TableCell>
                                                                )) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody style={{
                                                            height: tableData.length < 10 ? `${tableData.length * 50}px` : '500px',
                                                            overflowY: tableData.length >= 10 ? 'scroll' : 'visible'
                                                        }}>
                                                            {tableData.map((data, dataIndex) => (
                                                                <TableRow key={dataIndex} style={{ border: '2px solid black' }}>
                                                                    <TableCell className={`${classes.stickyColumn}`} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {moment(data.dateOne).format("DD")}
                                                                    </TableCell>
                                                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.rainFallAmount == 0 || data.rainFallAmount == undefined ? '-' : data.rainFallAmount}
                                                                    </TableCell>

                                                                    {sortedResultCol.length > 0 ? sortedResultCol.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    {sortedResultColFive.length > 0 ? sortedResultColFive.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : parseFloat(value).toFixed(1)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    {sortedResultColOne.length > 0 ? sortedResultColOne.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    {sortedResultColTwo.length > 0 ? sortedResultColTwo.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : (value)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    {sortedResultColThree.length > 0 ? sortedResultColThree.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : parseFloat(value).toFixed(1)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {isNaN(data.estTotal) || data.estTotal == 0 || data.estTotal == undefined ? '-' : parseInt(data.estTotal)}
                                                                    </TableCell>
                                                                    {sortedResultColFour.length > 0 ? sortedResultColFour.map((column) => {
                                                                        const value = data[column.colData];
                                                                        return (
                                                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                                                            </TableCell>
                                                                        );
                                                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {"-"}
                                                                    </TableCell>}
                                                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {data.osTotal == 0 || data.osTotal == undefined ? '-' : parseInt(data.osTotal)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow sx={{ border: "2px solid black" }}>
                                                                <TableCell className={`${classes.stickyColumn}`} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }} colSpan={1}> Total</TableCell>
                                                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }} colSpan={1}>
                                                                    {rainFallAmountTotal == undefined || rainFallAmountTotal == 0 ? '-' : parseFloat(rainFallAmountTotal).toFixed(1)}
                                                                </TableCell>
                                                                {sortedResultCol.length > 0 ? sortedResultCol.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                {sortedResultColFive.length > 0 ? sortedResultColFive.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseFloat(found.value).toFixed(1)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                {sortedResultColOne.length > 0 ? sortedResultColOne.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                {sortedResultColTwo.length > 0 ? sortedResultColTwo.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : (found.value)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                {sortedResultColThree.length > 0 ? sortedResultColThree.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseFloat(found.value).toFixed(1)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}

                                                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {estTotal == undefined ? '-' : estTotal == 0 ? '-' : parseInt(estTotal)}
                                                                </TableCell>
                                                                {sortedResultColFour.length > 0 ? sortedResultColFour.map((column) => {
                                                                    const found = totalRow.find(x => x.name == column.colData);
                                                                    return (
                                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                                                        </TableCell>
                                                                    );
                                                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {"-"}
                                                                </TableCell>}
                                                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                                    {osTotal == undefined ? '-' : osTotal == 0 ? '-' : parseInt(osTotal)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                                : null}
                            {tableData.length != 0 ?
                                <div className="pt-2">
                                    <ReactToPrint
                                        documentTitle={"Division Wise Crop Details - TEA"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                    />
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef}
                                            tableData={tableData}
                                            resultCol={resultCol}
                                            resultColOne={resultColOne}
                                            resultColTwo={resultColTwo}
                                            resultColThree={resultColThree}
                                            resultColFour={resultColFour}
                                            resultColFive={resultColFive}
                                            totalRow={totalRow}
                                            estTotal={estTotal}
                                            osTotal={osTotal}
                                            rainFallAmountTotal={rainFallAmountTotal}
                                            searchData={selectedSearchValues} />
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    )
}

